
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "SvgIcon",
})
export default class SvgIcon extends Vue {
  @Prop({ type: String, required: true }) readonly name!: string;
  @Prop({ type: String, default: "black" }) readonly color!: string;
  @Prop({ type: String, default: "24px" }) readonly size!: string;

  private svgContent = "";

  async mounted() {
    await this.loadSvg();
  }

  @Watch("name")
  async onNameChange() {
    await this.loadSvg();
  }

  async loadSvg() {
    try {
      // Importar SVG como string
      const svgModule = await import(`@/assets/icons/${this.name}.svg`);

      // Se o SVG foi importado como URL (webpack file-loader)
      if (typeof svgModule.default === "string") {
        const response = await fetch(svgModule.default);
        this.svgContent = await response.text();
      } else {
        // Se o SVG foi importado diretamente como string
        this.svgContent = svgModule.default || svgModule;
      }
    } catch (error) {
      console.warn(`Ícone não encontrado: ${this.name}.svg`);
      this.svgContent = `<svg width="24" height="24" viewBox="0 0 24 24"><text x="12" y="12" text-anchor="middle" dominant-baseline="middle" fill="currentColor">?</text></svg>`;
    }
  }

  get processedSvg(): string {
    if (!this.svgContent) return "";

    // Substituir cores fixas pela cor dinâmica
    return this.svgContent
      .replace(/fill="#[0-9A-Fa-f]{6}"/g, `fill="${this.fillColor}"`)
      .replace(/stroke="#[0-9A-Fa-f]{6}"/g, `stroke="${this.fillColor}"`)
      .replace(/fill="#[0-9A-Fa-f]{3}"/g, `fill="${this.fillColor}"`)
      .replace(/stroke="#[0-9A-Fa-f]{3}"/g, `stroke="${this.fillColor}"`);
  }

  get containerStyle() {
    return {
      width: this.size,
      height: this.size,
      display: "inline-block",
      lineHeight: "0",
    };
  }

  get fillColor(): string {
    // const colorMap: { [key: string]: string } = {
    //   black: this.$vuetify.theme.themes.light.black as string,
    //   purple100: this.$vuetify.theme.themes.light.purple100 as string,
    //   gray70: this.$vuetify.theme.themes.light.gray70 as string,
    //   pink: this.$vuetify.theme.themes.light.pink as string,
    //   white: this.$vuetify.theme.themes.light.white as string,
    // };

    // return colorMap[this.color] || colorMap.black;

    return String(this.$vuetify.theme.themes.light[this.color]);
  }
}
